import { render, staticRenderFns } from "./WorkPermNextReviewerModal.vue?vue&type=template&id=2e36fd7b&scoped=true&"
import script from "./WorkPermNextReviewerModal.vue?vue&type=script&lang=js&"
export * from "./WorkPermNextReviewerModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkPermNextReviewerModal.vue?vue&type=style&index=0&id=2e36fd7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36fd7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e36fd7b')) {
      api.createRecord('2e36fd7b', component.options)
    } else {
      api.reload('2e36fd7b', component.options)
    }
    module.hot.accept("./WorkPermNextReviewerModal.vue?vue&type=template&id=2e36fd7b&scoped=true&", function () {
      api.rerender('2e36fd7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WorkPermNextReviewerModal.vue"
export default component.exports